import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { useGetWeaveEnhancedInsuranceVerificationCustomizationFlagDetails } from '@frontend/insurance-verification';
import { useFeatureSubscriptionConfig } from './useFeatureSubscriptionConfig';

interface UseWivTeaserHandlerProps {
  locationIds: string[];
}
export const useWivTeaserHandler = ({ locationIds }: UseWivTeaserHandlerProps) => {
  const {
    isUpgradeOrTrialEligible,
    isFeatureActiveInAllLocations: isWivActive,
    isLoading,
  } = useFeatureSubscriptionConfig({
    locationIds,
    feature: Feature.WEAVE_VERIFY,
    checkBundleUpgrade: false,
  });

  // Fetching the EIV flag details
  const { locationIdWiseCustomizationFlagDetails: eivEnabledFlagsByLocationId } =
    useGetWeaveEnhancedInsuranceVerificationCustomizationFlagDetails();

  // Checking the EIV flag
  const hasEIVEnabled = locationIds?.some((locationId) => eivEnabledFlagsByLocationId?.[locationId]);

  // Show WIV verify button if either WIV is active or EIV flag is enabled
  const shouldShowInsuranceVerificationFeature = isWivActive || hasEIVEnabled;

  // Show WIV promotion if WIV or EIV is not active is not active and user is eligible for upgrade or trial
  const shouldShowWIVPromotion = !shouldShowInsuranceVerificationFeature && isUpgradeOrTrialEligible;

  return {
    isLoading,
    showWeaveVerify: shouldShowInsuranceVerificationFeature,
    showWeaveVerifyPromotion: shouldShowWIVPromotion,
  };
};
